export enum RefundRequestFilterFormField {
  USERNAME = 'UserName',
  EVENTNAME = 'EventName',
  MOBILENUMBER = 'MobileNumber',
  STATUS = 'Status',
  FromDate = 'FromDate',
  ToDate = 'ToDate',
}
export type RefundRequestFormValues = {
  [RefundRequestFilterFormField.USERNAME]: string | undefined;
  [RefundRequestFilterFormField.EVENTNAME]: string | undefined;
  [RefundRequestFilterFormField.MOBILENUMBER]: string | undefined;
  [RefundRequestFilterFormField.FromDate]: any | undefined;
  [RefundRequestFilterFormField.ToDate]: any | undefined;
  [RefundRequestFilterFormField.STATUS]: string | undefined;
  [RefundRequestFilterFormField.EVENTNAME]: string | undefined;
};